<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script >
import './assets/common/font.css';
export default {
  name: 'App',
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
body{
  background-color: #F7F7F7;
  font-family: FZCYJ;

}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue